import './App.css';
import Login from './pages/Login/Login';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import MainLayout from './components/MainLayout/MainLayout';
import Dashboard from './pages/Dashboard/Dashboard';
import Configuration from './pages/Configuration';
import NotificationsPage from './pages/Notifications/NotificationsPage';
import SettingsPage from './pages/Settings/SettingsPage';
import ProfilePage from './pages/Profile/ProfilePage';
import DataExtraction from './pages/DataExtraction/DataExtraction';
import BatchJobs from './pages/BatchJobs/BatchJobs';
import ManualNameReview from './pages/ManualNameReview/ManualNameReview';
import SystemHealth from './pages/SystemHealth/SystemHealth';
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Router>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route element={<MainLayout />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/configuracion" element={<Configuration />} />
            <Route path="/notifications" element={<NotificationsPage />} />
            <Route path="/settings" element={<SettingsPage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/data-extraction" element={<DataExtraction />} />
            <Route path="/batch-jobs" element={<BatchJobs />} />
            <Route path="/manual-name-review" element={<ManualNameReview />} />
            <Route path="/system-health" element={<SystemHealth />} />
          </Route>
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;